import {paramsToHttpParamsLike, UrlParams} from "./url-params-serializer";
import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {HttpDownloadFailureDialogComponent} from "./http-download-failure-dialog.component";
import {HttpClient, HttpResponse} from "@angular/common/http";

export type DownloadError = {
  message: string;
  stack?: string;
};

@Injectable({providedIn: "root"})
export class HttpDownloadService {
  constructor(private dialogService: DialogService, private http: HttpClient) {}

  downloadXHR(url: string, formData?: UrlParams): Promise<void> {
    const params = paramsToHttpParamsLike(formData);

    return this.http.get(url, {params, observe: "response", responseType: "blob"})
      .toPromise()
      .then((response: HttpResponse<Blob>) => {
        const blob = response.body;
        const filename = decodeURIComponent(response.headers.get("x-file-name"));

        // IE is special
        if (window && window.navigator && window.navigator["msSaveBlob"]) {
          window.navigator["msSaveBlob"](blob, filename);
          return;
        }

        const link = document.createElementNS("http://www.w3.org/1999/xhtml", "a") as HTMLAnchorElement;
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch((error) => {
        console.error(error);

        HttpDownloadFailureDialogComponent.show(this.dialogService, {error})
          .catch((e) => {
            console.error(e);
          });
      });
  }
}
